

































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppLabelColorSelector extends Vue {
  @Prop({ type: String }) readonly value!: string
  @Prop(String) readonly label!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: Number, default: 390 }) readonly width!: number
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String }) readonly confirm!: string

  model = ''

  showColorSelector = false

  rules = {
    required: (value:string) => !!value || 'Required.'
  }

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  colorChangedHandler (val: string) {
    this.model = val
    return val
  }
}
